import { render, staticRenderFns } from "./ManageAds.vue?vue&type=template&id=4add6ebf&scoped=true"
import script from "./ManageAds.vue?vue&type=script&lang=js"
export * from "./ManageAds.vue?vue&type=script&lang=js"
import style0 from "./ManageAds.vue?vue&type=style&index=0&id=4add6ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add6ebf",
  null
  
)

export default component.exports